import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useTranslation } from 'react-i18next';
import './AiSuggestions.css'; // reuse existing styles

const PublicReviewPage = () => {
    const { id } = useParams();
    console.log("🧪 Public review page - coffee_shop_id param:", id);
  const [searchParams] = useSearchParams();
  const coffeeShopId = searchParams.get('shop');
  const [reviews, setReviews] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchReviews = async () => {
      if (!id) return;

      const q = query(
        collection(db, 'reviews'),
        where('coffee_shop_id', '==', id)
      );
      const snapshot = await getDocs(q);
      setReviews(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };

    fetchReviews();
    
  }, [id]);
  

  const sentimentData = [
    { name: t('positive'), value: reviews.filter(r => r.feeling === 'positive').length },
    { name: t('neutral'), value: reviews.filter(r => r.feeling === 'neutral').length },
    { name: t('negative'), value: reviews.filter(r => r.feeling === 'negative').length },
  ];

  const COLORS = ['#4CAF50', '#FFC107', '#F44336'];
  const hasData = sentimentData.some(entry => entry.value > 0);

  return (
    <div className="suggestions-container1">
      <h2>📊 {t('customer_reviews')}</h2>

      {hasData ? (
        <ResponsiveContainer width="100%" height={250}>
          <PieChart>
            <Pie data={sentimentData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80}>
              {sentimentData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      ) : (
        <p>{t('no_sentiment_data')}</p>
        
      )}

      <button className="export-btn1" onClick={() => navigate(-1)}>⬅️ {t('back')}</button>

      {reviews.map((r) => (
        <div key={r.id} className="suggestion-card">
          <p>{r.comment}</p>
          <span className={`sentiment-tag ${r.feeling}`}>{t(r.feeling)}</span>
          {r.timestamp && (
            <small>{new Date(r.timestamp.seconds * 1000).toLocaleString()}</small>
          )}
        </div>
      ))}
    </div>
  );
};

export default PublicReviewPage;